export default __webpack_public_path__ + "static/media/277.f4081f03.png";